import { render } from "./GroupManagement.vue?vue&type=template&id=0bcdefd8&scoped=true&ts=true"
import script from "./GroupManagement.vue?vue&type=script&lang=ts"
export * from "./GroupManagement.vue?vue&type=script&lang=ts"

import "./GroupManagement.vue?vue&type=style&index=0&id=0bcdefd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcdefd8"],['__file',"src/views/GroupManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bcdefd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bcdefd8', __exports__)) {
    api.reload('0bcdefd8', __exports__)
  }
  
  module.hot.accept("./GroupManagement.vue?vue&type=template&id=0bcdefd8&scoped=true&ts=true", () => {
    api.rerender('0bcdefd8', render)
  })

}


export default __exports__